export const GeneroOptions = [
    {text: 'Femenino', value: 'F'},
    {text: 'Masculino', value: 'M'},
]